import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { setSidebarCollectionOpen } from '../actions/Collections';
import { updateLastFilesUpdateTime } from '../actions/Files';

import { APIupdateUserSettings } from '../api/User';

import { sendTrackingEvent } from '../helpers';
import { isArchive } from '../helpers/App';

const SidebarCollectionSwitch = ({
  dispatch,
  profile,
  sidebarCollectionOpen,
}) => {
  const intl = useIntl();

  if (!profile || isArchive()) {
    return null;
  }

  const handleSwitchSidebar = (e) => {
    e.preventDefault();
    dispatch(setSidebarCollectionOpen(!sidebarCollectionOpen));
    dispatch(updateLastFilesUpdateTime());
    APIupdateUserSettings(profile.uuid, { sidebar_collection_open: !sidebarCollectionOpen });

    if (!sidebarCollectionOpen) {
      sendTrackingEvent('collection-preview-open');
    }
  };

  return (
    <>
      <Button
        id="switch-sidebar-collection-icon"
        className={classnames('switch-sidebar-collection-button', { active: sidebarCollectionOpen })}
        color="link"
        onClick={handleSwitchSidebar}
        size="md"
        aria-label={sidebarCollectionOpen ? intl.formatMessage({ defaultMessage: 'Close Collection Builder' }) : intl.formatMessage({ defaultMessage: 'Open Collection Builder' })}
      >
        {sidebarCollectionOpen ? <i className="fas fa-folder-plus" /> : <i className="far fa-folder" /> }
      </Button>
      <UncontrolledTooltip fade={false} placement="bottom" target="switch-sidebar-collection-icon">
        {sidebarCollectionOpen ? (
          intl.formatMessage({ defaultMessage: 'Close Collection Builder' })
        ) : (
          intl.formatMessage({ defaultMessage: 'Open Collection Builder' })
        )}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  sidebarCollectionOpen: state.Collections.sidebarCollectionOpen,
});

SidebarCollectionSwitch.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object,
  sidebarCollectionOpen: PropTypes.bool.isRequired,
};

SidebarCollectionSwitch.defaultProps = {
  profile: null,
};

export default withRouter(connect(mapStateToProps)(SidebarCollectionSwitch));
